import withFeatureFlag from '@cld/with-feature-flags';

export const IfLogo = withFeatureFlag({ flagName: 'isLogo', flagValue: true })(() => import('components/Widget/Header/Logo'));
